import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Dimension } from './models/dimension';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * App Component.
 */
export class AppComponent implements OnInit, AfterViewInit
{
	/**
	 * Viewport dimension.
	 */
	private viewportDimension: Dimension = {
		'width': 2048,
		'height': 1365
	};

	private currentDimension: Dimension;

	/**
	 * Viewport ratio.
	 */
	private viewportRatio: number;

	/**
	 * Constructor.
	 */
	public constructor(translate: TranslateService)
	{
		let languages = ['de', 'en', 'fr'];
		const browserLanguage = translate.getBrowserLang();

		// Check browser language.
		if (browserLanguage && languages.indexOf(browserLanguage) !== -1)
		{
			// Reorder array.
			const index = languages.indexOf(browserLanguage);
			languages.splice(index, 1);
			languages.unshift(browserLanguage);

			translate.addLangs(languages);
			translate.setDefaultLang(browserLanguage);
			translate.use(browserLanguage);
		}
		else
		{
			translate.addLangs(languages);
			translate.setDefaultLang('de');
			translate.use('de');
		}
	}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		this.currentDimension = this.viewportDimension;
		this.viewportRatio = this.viewportDimension.width / this.viewportDimension.height;
	}

	/**
	 * Lifecycle-Hook: AfterViewInit.
	 */
	public ngAfterViewInit()
	{
		this.calculateViewportSize();
	}

	/**
	 * Eventhandler: Resize.
	 */
	@HostListener('window:resize')
	public resize(): void
	{
		this.calculateViewportSize();
	}

	/**
	 * Calculate and set the viewport size according to the window size.
	 */
	private calculateViewportSize()
	{
		const windowRatio = window.innerWidth / window.innerHeight;

		let viewportWidth = window.innerWidth;
		let viewportHeight = window.innerHeight;

		if (windowRatio < this.viewportRatio)
		{
			viewportHeight = window.innerWidth / this.viewportRatio;
		}
		else
		{
			viewportWidth = window.innerHeight * this.viewportRatio;
		}

		this.currentDimension.width = Math.round(viewportWidth);
		this.currentDimension.height = Math.round(viewportHeight);
	}

	/**
	 * Returns the current viewport size.
	 */
	public getViewportStyle()
	{
		return {
			'width': this.currentDimension.width + 'px',
			'height': this.currentDimension.height + 'px'
		};
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/app.component.ts